import { Action } from '@ngrx/store';
import { PaginatedApiResponse } from '@shared/models/paginated-api-response';
import { IArticle } from '@shared/shared/interfaces/article.interfaces';
import { Inspiration, InspirationFormat, InspirationQuery } from '../../models/inspiration.interface';

export const GET_ALL_INSPIRATIONS = '[Inspirations] Get All Inspirations';
export const GET_ALL_INSPIRATIONS_SUCCESS = '[Inspirations] Get All Inspirations Success';
export const GET_ALL_INSPIRATIONS_FAILURE = '[Inspirations] Get All Inspirations Failure';
export const RESET_ALL_INSPIRATIONS = '[Inspirations] Reset All Inspirations';

export const LOAD_MORE_INSPIRATIONS = '[Inspirations] Load More Inspirations';

export const GET_FEATURED_FORMAT_INSPIRATIONS = '[Inspirations] Get Featured Format Inspirations';
export const GET_FEATURED_FORMAT_INSPIRATIONS_SUCCESS = '[Inspirations] Get Featured Format Inspirations Success';

export const GET_FEATURED_INSPIRATIONS = '[Inspirations] Get Featured Inspirations';
export const GET_FEATURED_INSPIRATIONS_SUCCESS = '[Inspirations] Get Featured Inspirations Success';
export const RESET_FEATURED_INSPIRATIONS = '[Inspirations] Reset Featured Inspirations';

export const GET_VIEWED_INSPIRATION = '[Inspirations] Get Viewed Inspiration';
export const GET_VIEWED_INSPIRATION_SUCCESS = '[Inspirations] Get Viewed Inspiration Success';

export const GET_INSPIRATION_FORMATS = '[Inspirations] Get Inspiration Formats';
export const GET_INSPIRATION_FORMATS_SUCCESS = '[Inspirations] Get Inspiration Formats Success';
export const RESET_INSPIRATION_FORMATS = '[Inspirations] Reset Inspiration Formats';

export const GET_ARTICLE = '[Inspirations] Get Article';
export const GET_PRELOGIN_ARTICLE = '[Inspirations] Get Prelogin Article';
export const GET_ARTICLE_SUCCESS = '[Inspirations] Get Article Success';
export const GET_ARTICLE_FAIL = '[Inspirations] Get Article Fail';

export const GET_PUBLICATION = '[Inspirations] Get Publication';
export const GET_PRELOGIN_PUBLICATION = '[Inspirations] Get Prelogin Publication';
export const GET_PUBLICATION_SUCCESS = '[Inspirations] Get Publication Success';
export const GET_PUBLICATION_FAIL = '[Inspirations] Get Publication Fail';
export const REDIRECT_ARTICLE = '[Inspirations] Redirect to another article';
export const CLEAR_PUBLICATION = '[Inspirations] Clear Publication';
export const CLEAR_ARTICLE = '[Inspirations] Clear Article';

export class GetAllInspirations implements Action {
  readonly type = GET_ALL_INSPIRATIONS;
  constructor(public payload: InspirationQuery) {}
}

export class GetAllInspirationsSuccess implements Action {
  readonly type = GET_ALL_INSPIRATIONS_SUCCESS;
  constructor(public payload: PaginatedApiResponse<Inspiration>) {}
}

export class GetAllInspirationsFailure implements Action {
  readonly type = GET_ALL_INSPIRATIONS_FAILURE;
  constructor(public payload: PaginatedApiResponse<Inspiration>) {}
}

export class ResetAllInspirations implements Action {
  readonly type = RESET_ALL_INSPIRATIONS;
}

export class LoadMoreInspirations implements Action {
  readonly type = LOAD_MORE_INSPIRATIONS;
  constructor(public payload: InspirationQuery) {}
}

export class GetFeaturedFormatInspirations implements Action {
  readonly type = GET_FEATURED_FORMAT_INSPIRATIONS;
  constructor(public payload: InspirationQuery) {}
}

export class GetFeaturedFormatInspirationsSuccess implements Action {
  readonly type = GET_FEATURED_FORMAT_INSPIRATIONS_SUCCESS;
  constructor(
    public inspirations: PaginatedApiResponse<Inspiration>,
    public formatId: number
  ) {}
}

export class GetFeaturedInspirations implements Action {
  readonly type = GET_FEATURED_INSPIRATIONS;
  constructor(public payload: InspirationQuery) {}
}

export class GetFeaturedInspirationsSuccess implements Action {
  readonly type = GET_FEATURED_INSPIRATIONS_SUCCESS;
  constructor(public inspirations: PaginatedApiResponse<Inspiration>) {}
}

export class ResetFeaturedInspirations implements Action {
  readonly type = RESET_FEATURED_INSPIRATIONS;
}

export class GetArticle implements Action {
  readonly type = GET_ARTICLE;
  constructor(public payload: string) {}
}

export class GetPreloginArticle implements Action {
  readonly type = GET_PRELOGIN_ARTICLE;
  constructor(public payload: string) {}
}

export class GetArticleSuccess implements Action {
  readonly type = GET_ARTICLE_SUCCESS;
  constructor(public payload: IArticle) {}
}

export class GetArticleFail implements Action {
  readonly type = GET_ARTICLE_FAIL;
  constructor(public payload: any) {}
}

export class GetPublication implements Action {
  readonly type = GET_PUBLICATION;
  constructor(public payload: string) {}
}

export class GetPreloginPublication implements Action {
  readonly type = GET_PRELOGIN_PUBLICATION;
  constructor(public payload: string) {}
}

export class GetPublicationSuccess implements Action {
  readonly type = GET_PUBLICATION_SUCCESS;
  constructor(public payload: IArticle) {}
}

export class GetPublicationFail implements Action {
  readonly type = GET_PUBLICATION_FAIL;
  constructor(public payload: any) {}
}

export class GetInspirationFormats implements Action {
  readonly type = GET_INSPIRATION_FORMATS;
}

export class GetInspirationFormatsSuccess implements Action {
  readonly type = GET_INSPIRATION_FORMATS_SUCCESS;
  constructor(public payload: Array<InspirationFormat>) {}
}

export class ResetInspirationFormats implements Action {
  readonly type = RESET_INSPIRATION_FORMATS;
}

export class RedirectArticle implements Action {
  readonly type = REDIRECT_ARTICLE;
  constructor(public payload: string) {}
}

export class ClearPublication implements Action {
  readonly type = CLEAR_PUBLICATION;
}

export class ClearArticle implements Action {
  readonly type = CLEAR_ARTICLE;
}

export type InspirationAction =
  | GetInspirationFormats
  | GetInspirationFormatsSuccess
  | ResetInspirationFormats
  | GetAllInspirationsFailure
  | GetAllInspirations
  | GetAllInspirationsSuccess
  | ResetAllInspirations
  | LoadMoreInspirations
  | GetFeaturedFormatInspirations
  | GetFeaturedFormatInspirationsSuccess
  | GetFeaturedInspirations
  | GetFeaturedInspirationsSuccess
  | ResetFeaturedInspirations
  | GetPublication
  | GetPreloginPublication
  | GetPublicationSuccess
  | GetArticle
  | GetPreloginArticle
  | GetArticleSuccess
  | RedirectArticle
  | ClearPublication
  | ClearArticle;
